import React from 'react'
import Header from '../ui-kit/header/Header';
import Link from 'next/link';
import ProjectCard from '../ui-kit/cards/ProjectCard';
import { IProject } from '../../models/Project';
import { RightChevronSvg } from '../ui-kit/icons/ChevronSvg';
import LinkWithChevron from '../ui-kit/general/LinkWithChevron';
import Grid from '../ui-kit/layout/Grid';
import SolutionCard from '../ui-kit/cards/SolutionCard';

type Props = {
	solutions: any[]
}

const SolutionsSection = ({ solutions }: Props) => {

	return (
		<section className="my-8">
			<Grid title="Soluciones" viewAll={{ href: '/soluciones', text: 'Ver Todas' }}>
				{solutions && solutions.map(solution => (
					<SolutionCard key={solution.id} solution={solution} />
				))}
			</Grid>
			{!solutions || solutions.length === 0 && <div className="text-gray-400 dark:text-gray-200">Todavía no se ha publicado una solución</div>}
		</section>
	)
}

export default SolutionsSection
